import React from 'react'
import { Checkbox } from 'antd'
import { FormattedMessage, useIntl } from 'react-intl'

import styles from './Renew.module.css'

const StoreRenewStatement = ({ storeRenewList, setAgreement, agreement }) => {
  const { formatMessage } = useIntl()

  return (
    <div className={styles.statement}>
      <div className={styles.title}>{formatMessage({ id: 'renew-statement' })}</div>
      <div className={styles['price-detail']}>
        <div className={styles['renew-price']}>
          <div className={styles['price-item']}>
            <div className="renew-price-title">{storeRenewList.renewalName}</div>
            <span className={styles.price}>¥ {storeRenewList.price / 100}</span>
          </div>
          <div className={styles['price-item']}>
            <div className="renew-price-title renew-total-title">Total</div>
            <span className={styles.price}>¥ {storeRenewList.price / 100}</span>
          </div>
        </div>
        <Checkbox
          className={styles['agreement-box']}
          checked={agreement}
          onChange={(e) => setAgreement(e.target.checked)}
        >
          <FormattedMessage
            id="member-renew-agreement"
            values={{
              agreement: (
                <a
                  rel="noopener noreferrer"
                  target="_blank"
                  className={styles['agreement-content']}
                  href={
                    'https://pro-cms.padi.com/sites/default/files/documents/training-hub/725DTSC_%E6%95%99%E7%BB%83%E4%BC%9A%E5%91%98%E8%B5%84%E6%A0%BC%E5%92%8C%E6%8E%88%E6%9D%83%E5%8D%8F%E8%AE%AE%E4%B9%A6_%E8%A1%A8%E5%8D%95%E9%9B%86%E5%90%88_2026.pdf'
                  }
                >
                  <FormattedMessage id="member-renew-agreement-name" />
                </a>
              ),
            }}
          />
        </Checkbox>
      </div>
    </div>
  )
}

export default StoreRenewStatement
